<template>
  <div class="docs">
    <div class="container">
      <div class="docs__wrapper">
        <div class="docs__top">
          <h1 class="docs__title">
            {{ t('docs.policy.title') }}
          </h1>
        </div>

        <div class="docs__main">
          <div
              v-for="(block, index) in content"
              :key="index"
              class="docs__block"
          >
            <!-- Заголовок блока -->
            <h2 v-if="block.title" class="docs__subtitle">
              {{ block.title }}
            </h2>

            <!-- Тексты (text-1, text-2, text-3 ...) -->
            <p
                v-for="(value, key) in textFields(block)"
                :key="key"
                class="docs__text"
            >
              {{ value }}
            </p>

            <!-- Список -->
            <ul v-if="block.list" class="docs__list">
              <li
                  v-for="(item, key) in block.list"
                  :key="key"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t, tm } = useI18n()

const content = computed(() => tm('docs.policy.content') || [])

const textFields = (block) => {
  return Object.keys(block)
      .filter(key => key.startsWith('text'))
      .sort()
      .reduce((acc, key) => {
        acc[key] = block[key]
        return acc
      }, {})
}

</script>

<style lang="scss" scoped>
.docs {
  padding-top: 150px;
  color: $white;

  &__top {
    border-bottom: 1px solid #1e1e1e;

    & h1 {
      width: fit-content;
      padding-bottom: 10px;
      border-bottom: 3px solid #3b3b3b;
      color: #3b3b3b;
      font-size: 24px;
      font-weight: 700;
      line-height: 30px;
    }
  }

  &__main {
    margin-top: 50px;
  }
}

:deep(ul) {
  padding-left: 20px;
}
:deep(p) {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
:deep(li) {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
:deep(a) {
  color: #ff0000;
  font-weight: 500;

  @include hover {
    color: #af0000;
  }
}

@media (max-width: 750px) {
  .docs {
    &__top {
      padding-block: 40px;
    }

    &__title {
      font-size: 42px;
    }
  }

  :deep(p) {
    font-size: 16px;
  }
  :deep(li) {
    font-size: 16px;
  }
}

.docs__block {
  &:not(:last-child) {
    margin-bottom: 40px;
  }
}

.docs__subtitle {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: black;
}

.docs__text {
  margin-bottom: 10px;
  color: black;
}

.docs__list {
  margin-top: 10px;
  color: black;
}

</style>